<template>
    <div v-if="goodsAttrList.length">
        <div class="mark arrow2 col999" @click="onPopup">
            <div class="item"><img src="../../../../../assets/img/b2b/icon_pdf.png" />商品资料包</div><span class="colFF7A45">点击查看产品手册</span>
        </div>
        <MeansPopup v-if="goodsAttrList.length" :goodsAttrList='goodsAttrList' :visible.sync='meansPopup' />
    </div>
</template>

<script>
import MeansPopup from './meansPopup'
import { getGoodAttr } from '../../../api/product'
export default {
    components: {
        MeansPopup
    },
    props: {
        goodsId: {
            type: String,
            defalut: ''
        }
    },
    data () {
        return {
            meansPopup: false,
            goodsAttrList: []
        }
    },
    methods: {
        onPopup () {
            this.meansPopup = !this.meansPopup
        },
        async getGoodAttrData () {
            const { data } = await getGoodAttr({
                spuId: this.goodsId
            })
            this.goodsAttrList = data
        }
    },
    mounted () {
        this.getGoodAttrData()
    }
}
</script>

<style lang="scss" scoped>
.mark {
    font-size: 28px;
    position: relative;
    background-color: #ffffff;
    height: 96px;
    line-height: 96px;
    padding: 0 32px;
    display: flex;
    span {
        color: #000;
    }
    .item {
        margin-right: 40px;
        color: #333333;
        text-align: left;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        display: flex;
        align-items: center;
        img {
            width: 32px;
            height: 32px;
            margin-right: 12px;
        }
    }
}
</style>